module.exports = __webpack_public_path__ + "img/Pumpkin Spice Frappe.efdf1241.svg";